import { datadogRum } from '@datadog/browser-rum'
import { reactPlugin } from '@datadog/browser-rum-react'
import { resolveDeploymentEnv } from './config/getEnvVars'
import { DATADOG_SERVICE_NAME, isDatadogRumInitialized } from './utils/datadog'

const applicationId = '5b80df15-f9dd-405a-9bfd-d8328fe3c851'
const clientToken = 'pub2288b7713f824d27503b6667a599971a'
const site = 'us5.datadoghq.com'
const version = __APP_VERSION__
const env = resolveDeploymentEnv()

if (!isDatadogRumInitialized()) {
  datadogRum.init({
    applicationId,
    clientToken,
    site,
    service: DATADOG_SERVICE_NAME,
    env,
    version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,
    plugins: [reactPlugin({ router: false })],
  })
}
